import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import PageContentExpresso from '../../components/PageContentExpresso';
import ImgContentCatalogo from '../../images/catalogo-img-pq-e1563481726661.jpg';
import getConfigRecursosExpressoInstalado from '../../data/configRecursosExpressoInstalado';

export default ({ location }) => {
  const intl = useIntl();

  const configRecursosExpressoInstalado = getConfigRecursosExpressoInstalado({ intl });

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template page-template-page-expresso page-template-page-expresso-php page page-id-274 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Catálogo Expresso Instalado | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <PageContentExpresso
          titulo={intl.formatMessage({ id: 'Catálogo Expresso Instalado' })}
          Conteudo={() => (
            <>
              <p><img className="right alignleft wp-image-654 size-full imagem-conteudo-catalogo" style={{ marginLeft: 10 }} width="500" height="362" src={ImgContentCatalogo} alt={intl.formatMessage({ id: 'Imagem conteudo catálogo' })} /></p>
              <p><strong>{intl.formatMessage({ id: 'O QUE É NECESSÁRIO PARA MONTAR UM CATÁLOGO EXPRESSO?' })}</strong></p>
              <p>{intl.formatMessage({ id: 'Para montar um Catálogo Expresso é necessário apenas que os dados de produtos estejam em algum formato eletrônico (EXCEL, Texto, Banco de Dados, etc). Dados em outros formatos (PDF, WORD, etc) serão avaliados' })}.</p>
              <p><strong>{intl.formatMessage({ id: 'QUEM UTILIZA?' })}</strong></p>
              <p>{intl.formatMessage({ id: 'O Catálogo Expresso foi desenvolvido para o mercado de peças em geral, atendendo FABRICANTES e DISTRIBUIDORES' })}.</p>
            </>
          )}
          configRecursos={configRecursosExpressoInstalado}
        />
      </div>
    </Layout>
  );
};
